// ============================================
// FILE LOCATION: src/pages/portal/PortalRoutes.jsx
// ============================================

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PortalProvider } from '../../contexts/PortalContext';

// Import portal pages
import PortalLogin from './PortalLogin';
import PortalDashboard from './PortalDashboard';
import PortalJobs from './PortalJobs';
import PortalInvoices from './PortalInvoices';
import PortalInvoiceDetail from './PortalInvoiceDetail';
import PortalRequestQuote from './PortalRequestQuote';

/**
 * Portal Routes wrapper
 * 
 * Wraps all portal routes in a single PortalProvider so state
 * (customer, business, token) persists across page navigation.
 */
const PortalRoutes = () => {
  return (
    <PortalProvider>
      <Routes>
        {/* Token validation / login */}
        <Route path=":token" element={<PortalLogin />} />
        
        {/* Authenticated portal pages */}
        <Route path="dashboard" element={<PortalDashboard />} />
        <Route path="jobs" element={<PortalJobs />} />
        <Route path="invoices" element={<PortalInvoices />} />
        <Route path="invoices/:id" element={<PortalInvoiceDetail />} />
        <Route path="request-quote" element={<PortalRequestQuote />} />
        
        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </PortalProvider>
  );
};

export default PortalRoutes;